export type PotholeRagBandSlug = 'green' | 'amber' | 'red';

export interface PotholeRagBand {
  readonly slug: PotholeRagBandSlug;
  readonly label: string;
  readonly min: number;
  readonly max: number;
  readonly color: string;
}

export const POTHOLE_RAG_BANDS: readonly PotholeRagBand[] = [
  { slug: 'green', label: 'Green', min: 0, max: 9.99, color: '#65fa00' },
  { slug: 'amber', label: 'Amber', min: 10, max: 19.99, color: '#ffbc00' },
  { slug: 'red', label: 'Red', min: 20, max: 250, color: '#ff0000' },
] as const;

export const POTHOLE_RAG_COLOR_SCHEME = {
  min: POTHOLE_RAG_BANDS[0].color,
  max: POTHOLE_RAG_BANDS[2].color,
} as const;

export const POTHOLE_RAG_THRESHOLDS = [10, 20, 250] as const;

export const POTHOLE_RAG_THRESHOLD_ATTRIBUTE = 'Ave Depth';

export const POTHOLE_RAG_LEGEND_ITEMS = [
  { color: POTHOLE_RAG_BANDS[0].color, label: '0–9.99' },
  { color: POTHOLE_RAG_BANDS[1].color, label: '10–19.99' },
  { color: POTHOLE_RAG_BANDS[2].color, label: '20–250' },
] as const;
